






























import { Vue, Component } from 'vue-property-decorator'

@Component
export default class Roles extends Vue {
  private rolesBase: { title: string, role: string, weapon: string, playstyle: string, summary: string }[] = [
    { title: 'Warrior', role: 'Physical Damage', weapon: 'Swords/Greatswords', playstyle: 'Allrounder', summary: 'Warriors have a balance of attacks, buffs, and debuffs.' },
    { title: 'Mage', role: 'Magical Damage', weapon: 'Staves', playstyle: 'Status Effects, AoE Damage', summary: 'Mages have high damage, strong buffs, draining debuffs, and must manage their mana.' },
    { title: 'Archer', role: 'Physical Damage', weapon: 'Bows', playstyle: 'Burst Damage', summary: 'Archers have excellent burst damage and debuffs.' },
    { title: 'Knight', role: 'Tank, Physical Damage', weapon: 'Bulwark Shields', playstyle: 'Buffs, Group Buffs, Aggro Control', summary: 'Knights manage aggro and support group defense.' },
    { title: 'Priest', role: 'Healer/Support, Magical Damage', weapon: 'Holy Symbols', playstyle: 'Heals, Buffs', summary: 'Priests heal allies and improve their resource generation.' }
  ]

  private rolesAdvanced: { title: string, path: string, role: string, weapon: string, playstyle: string, summary: string }[] = [
    { title: 'Warlord', path: 'Warrior', role: 'Physical Damage', weapon: 'Claymores', playstyle: 'Build & Burst Phases, Resource Management', summary: 'Warlords generate resources through basic attacks and spend them for high damage.' },
    { title: 'Arcane Archer', path: 'Archer', role: 'Magical Damage', weapon: 'Enchanted Bows', playstyle: 'High Damage, Mage Killer', summary: 'Arcane Archers debuff enemies, drain mana, and charge their arrows for high damage.' },
    { title: 'Evoker', path: 'Mage', role: 'Magical Damage', weapon: 'Arcane Staves', playstyle: 'Burn & Recover Phases', summary: 'Evokers rotate through burn phases dealing high damage and building phases buffing and recovering mana.' },
    { title: 'Master Archer', path: 'Archer + Mage', role: 'Physical Damage', weapon: 'Greatbows', playstyle: 'Burst Group Damage', summary: 'Master Archers deal high damage to single targets and groups.' },
    { title: 'Battle Mage', path: 'Warrior + Mage', role: 'Magical Damage', weapon: 'Elemental Halberds', playstyle: 'High Damage, Resource Management', summary: 'Battle Mages do more damage the more mana they have and must carefully plan their moves.' },
    { title: 'Ranger', path: 'Warrior + Archer', role: 'Physical Damage', weapon: 'Blade & Bow', playstyle: 'Debuffs', summary: 'Rangers excel at debuffing and debilitating enemies, greatly reducing their threat and exposing their weaknesses.' },
    { title: 'Rogue', path: 'Warrior + Archer', role: 'Physical Damage', weapon: 'Daggers', playstyle: 'Buffs, Burst Damage', summary: 'Rogues avoid damage through buffs and build damage exponentially for every turn without taking damage. Then they execute.' },
    { title: 'Warlock', path: 'Mage + Priest', role: 'Magical Damage', weapon: 'Sacrificial Knife', playstyle: 'Debuffs', summary: 'Warlocks apply long-lasting debuffs on enemies that build into massive damage over time.' },
    { title: 'Paladin', path: 'Knight + Priest', role: 'Tank, Physical Damage', weapon: 'Sword & Shield', playstyle: 'Aggro Control, Buffs, Self-Sustain', summary: 'Paladins manage enemy aggro and sustain through self-buffs and self-healing.' },
    { title: 'Centurion', path: 'Warrior + Knight', role: 'Tank, Physical Damage', weapon: 'Short Blade & Shield', playstyle: 'Aggro Control', summary: 'Centurions gain damage reduction for each attack and play more aggressively than traditional tanks.' },
    { title: 'Spellward', path: 'Knight + Mage', role: 'Tank, Magical Damage', weapon: 'Infused Amulet', playstyle: 'Aggro Control, Buffs, AoE Damage', summary: 'Spellwards use elemental magic to reduce and reflect damage.' },
    { title: 'Diviner', path: 'Priest', role: 'Healer/Support', weapon: 'Relics', playstyle: 'Damage Prevention, Heals, Support', summary: 'Diviners apply damage-absorbing shields and improve party resource regeneration.' }
  ]
}
